var exports = {
  "jk": "x31de4314--c93453--jk",
};

module.exports = exports;
